import {useRouter} from 'next/router';

import Listing from '@components/product/list';
import styles from '@styles/listing.module.scss';
import SeoMeta from '@components/common/seo';
function ProductList() {
	const router = useRouter();
	const {slug, ...filters} = router.query;
	let category = null;
	if (slug && slug.length === 1) {
		category = slug[0];
	}

	return (
		<div
			className={styles.listingPageBlock}
			style={{
				marginBottom: '3rem',
			}}
		>
			<SeoMeta
				title={`Ditybit | Drop Auctions | Bid when you Dare!`}
				url={router.asPath}
				description={`xhilarating  shopping is here! Bid for products while the price drops, and when the price is right, HIT BUY!`}
				keywords={`drop auctions, auctions, online auction, bid`}
			/>
			<Listing
				styles={styles}
				filters={filters}
				category={category}
				isAuction={true}
			/>
		</div>
	);
}

ProductList.Layout = true;

export default ProductList;
